import { todayCalendarDate } from '../../../../components/calendar/monthGrid';
import { uid } from '../../../../lib/uid';
import type { JobPostingTagRequest, RecruitmentUserOption } from '../vacancyTypes';

/** The Job Posting stage as a form holds it — a draft, so the date may be half-typed. */
export interface JobPostingDraft {
  postedByUserId: string | null;
  postedDate: string;
  remarks: string;
}

/** A new posting opens answerable: posted by whoever is recording it, today. */
export function emptyJobPostingDraft(currentUserId: string | null): JobPostingDraft {
  return { postedByUserId: currentUserId, postedDate: todayCalendarDate(), remarks: '' };
}

export function isJobPostingDraftComplete(draft: JobPostingDraft): boolean {
  return draft.postedByUserId != null && draft.postedByUserId !== '' && draft.postedDate.length > 0;
}

export function toJobPostingRequest(draft: JobPostingDraft): JobPostingTagRequest {
  return {
    postedByUserId: draft.postedByUserId ?? '',
    postedDate: draft.postedDate,
    remarks: draft.remarks.trim() || null,
  };
}

/** Autogenerate's half of the stage: a live account, today, a synthetic note. Nothing when no account loaded. */
export function sampleJobPostingDraft(users: RecruitmentUserOption[]): JobPostingDraft {
  return {
    postedByUserId: users.length > 0 ? users[Math.floor(Math.random() * users.length)].userId : null,
    postedDate: todayCalendarDate(),
    remarks: `Posted on the bulletin board and the agency website (sample ${uid().slice(0, 6).toUpperCase()}).`,
  };
}
